import { cx } from "@emotion/css";
import Skeleton from "@mui/material/Skeleton";

interface ArticleViewSkeletonProps {
	className?: string;
}

const LINES = ["100%", "96%", "100%", "88%", "100%", "72%"];

/** Ładowanie ArticleView: ta sama karta, nagłówek (breadcrumb, tytuł, spis treści) i kilka linii treści. */
export function ArticleViewSkeleton({ className }: ArticleViewSkeletonProps) {
	return (
		<div className={cx("article-view", className)}>
			<div className="article-view--card">
				<div className="article-view--header">
					<Skeleton variant="text" width={220} height={24} />
					<div className="flex items-start justify-between flex-wrap gap-16">
						<div className="flex flex-col gap-8 article-view--title-block">
							<Skeleton variant="rounded" width="70%" height={48} />
						</div>
						<Skeleton variant="rounded" width={150} height={44} />
					</div>
				</div>
				<div className="flex flex-col gap-12">
					<Skeleton variant="rounded" width={180} height={30} />
					{LINES.map((width, i) => (
						<Skeleton key={i} variant="text" width={width} height={24} />
					))}
				</div>
			</div>
		</div>
	);
}
